/*
  Canastyle product page.
  Variant picker, gallery, multi-buy tiers, mobile sticky bar, size guide drawer,
  pairs well with quick add, and Shopify recommendations.
  Add to cart on the main product uses Dawn's own product-form element.
*/
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var fmt = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    var value = (Number(cents) || 0) / 100;
    var fixed = value.toFixed(2).split('.');
    function group(n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return group(Math.round(value), ',');
        case 'amount_with_comma_separator': return group(fixed[0], '.') + ',' + fixed[1];
        case 'amount_no_decimals_with_comma_separator': return group(Math.round(value), '.');
        default: return group(fixed[0], ',') + '.' + fixed[1];
      }
    });
  }

  /* Same flow as Dawn's product-form, for adds that don't come from the main form. */
  function addToCart(variantId, quantity) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', quantity || 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Could not add to cart');
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return res;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cs-pairs', productVariantId: variantId, cartData: res });
        }
        cart.renderContents(res);
        cart.classList.remove('is-empty');
        return res;
      });
  }

  function focusables(root) {
    return Array.prototype.slice.call(root.querySelectorAll('button:not([disabled]), [href], select, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null && !el.hasAttribute('hidden'); });
  }

  class CsProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var json = this.querySelector('[data-cs-product-json]');
      if (!json) return;
      this._ready = true;
      this.data = JSON.parse(json.textContent);
      this.fmt = this.data.moneyFormat;
      this.selected = this.data.initial.slice();
      this.order = this.buildOrder();
      this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-option-pos]'));
      this.atc = this.querySelector('[data-cs-atc]');
      this.form = this.atc ? this.atc.form : null;
      this.idInput = this.querySelector('[data-cs-variant-input]');
      this.qtyInput = this.querySelector('[data-cs-qty-input]');
      this.gallery = this.querySelector('[data-cs-gallery]');
      this.tierQty = 1;
      this.activeTier = null;
      this.tierTotal = 0;
      this.bindPicker();
      this.bindGallery();
      this.bindTiers();
      this.bindAtc();
      this.bindSticky();
      this.bindGuide();
      this.bindPairs();
      this.update(false, false);
    }

    /* Color first, then the other options in their product order. */
    buildOrder() {
      var n = this.data.optionCount, c = this.data.colorPos - 1, order = [];
      if (c >= 0) order.push(c);
      for (var i = 0; i < n; i++) if (i !== c) order.push(i);
      return order;
    }

    /* A value is selectable when a variant has it and matches every earlier selection. */
    allowed(idx, value) {
      var before = this.order.slice(0, this.order.indexOf(idx)), sel = this.selected;
      return this.data.variants.some(function (v) {
        if (v.options[idx] !== value) return false;
        for (var k = 0; k < before.length; k++) {
          var j = before[k];
          if (sel[j] != null && v.options[j] !== sel[j]) return false;
        }
        return true;
      });
    }

    match(exact) {
      var sel = this.selected;
      for (var i = 0; i < this.data.variants.length; i++) {
        var v = this.data.variants[i], ok = true;
        for (var j = 0; j < v.options.length; j++) {
          if (sel[j] == null) { if (exact) { ok = false; break; } continue; }
          if (sel[j] !== v.options[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    pick(idx, value) {
      this.selected[idx] = value;
      var at = this.order.indexOf(idx);
      for (var k = at + 1; k < this.order.length; k++) {
        var j = this.order[k];
        if (this.selected[j] != null && !this.allowed(j, this.selected[j])) this.selected[j] = null;
      }
      this.update(idx === this.data.colorPos - 1, true);
    }

    bindPicker() {
      var self = this;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-option-pos] [data-value]');
        if (!b || !self.contains(b)) return;
        if (b.getAttribute('aria-disabled') === 'true') return;
        var idx = Number(b.closest('[data-option-pos]').getAttribute('data-option-pos')) - 1;
        var value = b.getAttribute('data-value');
        self.pick(idx, value);
        var again = b.closest('[data-option-pos]').querySelector('[data-value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]');
        if (again) again.focus();
      });
      this.addEventListener('keydown', function (e) {
        if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) === -1) return;
        var group = e.target.closest('[role="radiogroup"]');
        if (!group || !self.contains(group)) return;
        var items = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]:not([aria-disabled="true"])'));
        var i = items.indexOf(e.target);
        if (i === -1) return;
        e.preventDefault();
        var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? items[(i + 1) % items.length] : items[(i - 1 + items.length) % items.length];
        next.focus();
      });
    }

    update(colorChanged, fromUser) {
      var self = this, sel = this.selected, anyDisabled = false;
      this.groups.forEach(function (g) {
        var idx = Number(g.getAttribute('data-option-pos')) - 1;
        g.querySelectorAll('[data-value]').forEach(function (b) {
          var val = b.getAttribute('data-value');
          b.setAttribute('aria-checked', sel[idx] === val ? 'true' : 'false');
          if (self.allowed(idx, val)) {
            b.removeAttribute('aria-disabled');
          } else {
            b.setAttribute('aria-disabled', 'true');
            if (idx !== self.data.colorPos - 1) anyDisabled = true;
          }
        });
        var label = g.querySelector('[data-cs-value]');
        if (label) label.textContent = sel[idx] || '';
      });
      var hint = this.querySelector('[data-cs-hint]');
      if (hint) hint.hidden = !anyDisabled;

      this.variant = this.match(true);
      var shown = this.variant || this.match(false);
      if (shown) {
        this.updatePrice(shown);
        this.updateTiers(shown);
        if (colorChanged) this.showMedia(shown.media, sel[this.data.colorPos - 1]);
      }
      this.updateAtc(shown);

      if (fromUser && this.variant && this.getAttribute('data-update-url') === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', this.variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    updatePrice(v) {
      var now = this.querySelector('[data-cs-price-now]');
      if (now) now.textContent = formatMoney(v.price, this.fmt);
      var was = this.querySelector('[data-cs-price-was]');
      var onSale = v.compare > v.price;
      if (was) {
        was.hidden = !onSale;
        var amt = was.querySelector('[data-cs-price-was-amount]');
        if (amt) amt.textContent = formatMoney(v.compare, this.fmt);
      }
      var save = this.querySelector('[data-cs-price-save]');
      if (save) {
        save.hidden = !onSale;
        save.textContent = (save.getAttribute('data-template') || '').replace('[amount]', formatMoney(v.compare - v.price, this.fmt));
      }
    }

    tierPrice(price, btn) {
      var qty = Number(btn.getAttribute('data-qty')) || 1;
      var type = btn.getAttribute('data-type');
      var value = Number(btn.getAttribute('data-value')) || 0;
      var full = price * qty, total = full;
      if (type === 'pct') total = Math.round(full * (100 - value) / 100);
      else if (type === 'amount') total = full - Math.round(value * 100);
      else if (type === 'price') total = Math.round(value * 100);
      return { qty: qty, full: full, total: Math.max(0, total) };
    }

    updateTiers(v) {
      var self = this;
      if (!this.tierBtns) return;
      this.tierBtns.forEach(function (b) {
        var t = self.tierPrice(v.price, b);
        var p = b.querySelector('[data-cs-tier-price]');
        if (p) p.textContent = formatMoney(t.total, self.fmt);
        var each = b.querySelector('[data-cs-tier-each]');
        if (each) each.textContent = self.data.strings.each.replace('[price]', formatMoney(v.price, self.fmt));
        var s = b.querySelector('[data-cs-tier-save]');
        if (s) {
          s.hidden = t.full - t.total <= 0;
          s.textContent = self.data.strings.save.replace('[amount]', formatMoney(t.full - t.total, self.fmt));
        }
        if (b === self.activeTier) self.tierTotal = t.total;
      });
    }

    updateAtc(shown) {
      var s = this.data.strings, v = this.variant, label, disabled = false;
      if (!v) {
        label = this.data.cupPos > 0 ? s.selectBandCup : s.selectSize;
        disabled = true;
      } else if (!v.available) {
        label = s.soldOut;
        disabled = true;
      } else if (this.tierQty > 1) {
        label = s.addQty.replace('[qty]', this.tierQty).replace('[unit]', s.unitPlural).replace('[price]', formatMoney(this.tierTotal, this.fmt));
      } else {
        label = s.add;
      }
      if (this.idInput) this.idInput.value = v && v.available ? v.id : '';
      if (this.qtyInput) this.qtyInput.value = this.tierQty;
      if (this.atc) {
        var span = this.atc.querySelector('[data-cs-atc-label]');
        if (span) span.textContent = label;
        if (disabled) this.atc.setAttribute('aria-disabled', 'true');
        else this.atc.removeAttribute('aria-disabled');
      }
      if (this.sticky) {
        var meta = this.sticky.querySelector('[data-cs-sticky-meta]');
        var parts = this.selected.filter(function (x) { return x != null; });
        var priceShown = this.tierQty > 1 && v ? this.tierTotal : (shown ? shown.price : 0);
        if (meta) meta.textContent = [formatMoney(priceShown, this.fmt)].concat(parts).join(', ');
        var sb = this.sticky.querySelector('[data-cs-sticky-btn]');
        if (sb) sb.textContent = v ? (v.available ? s.add : s.soldOut) : s.stickySelect;
      }
    }

    showMedia(mediaId) {
      if (!this.gallery || !mediaId) return;
      var item = this.gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (!item) return;
      this.gallery.insertBefore(item, this.gallery.firstElementChild);
      var initial = Number(this.gallery.getAttribute('data-initial')) || 8;
      Array.prototype.forEach.call(this.gallery.children, function (li, i) { li.classList.toggle('is-extra', i >= initial); });
      var img = item.querySelector('img');
      if (img) img.loading = 'eager';
      this.gallery.scrollLeft = 0;
      this.setCount(1);
    }

    setCount(n) {
      var el = this.querySelector('[data-cs-gallery-index]');
      if (el) el.textContent = n;
    }

    bindGallery() {
      var self = this, g = this.gallery;
      if (!g) return;
      g.addEventListener('scroll', function () {
        var w = g.clientWidth;
        if (w) self.setCount(Math.round(g.scrollLeft / w) + 1);
      }, { passive: true });
      var toggle = this.querySelector('[data-cs-gallery-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var open = g.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          toggle.textContent = open ? toggle.getAttribute('data-label-less') : toggle.getAttribute('data-label-more');
          if (!open) g.scrollIntoView({ block: 'start' });
        });
      }
    }

    bindTiers() {
      var self = this;
      var mb = this.querySelector('[data-cs-mb][data-mode="tiers"]');
      if (!mb) return;
      this.tierBtns = Array.prototype.slice.call(mb.querySelectorAll('.cs-tier'));
      this.activeTier = this.tierBtns[0] || null;
      mb.addEventListener('click', function (e) {
        var b = e.target.closest('.cs-tier');
        if (!b) return;
        self.tierBtns.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        self.activeTier = b;
        self.tierQty = Number(b.getAttribute('data-qty')) || 1;
        self.update(false, false);
      });
    }

    focusMissing() {
      var self = this, idx = null;
      for (var k = 0; k < this.order.length; k++) {
        if (this.selected[this.order[k]] == null) { idx = this.order[k]; break; }
      }
      var group = this.groups.filter(function (g) { return Number(g.getAttribute('data-option-pos')) - 1 === idx; })[0] || this.groups[0];
      if (!group) return;
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var b = group.querySelector('[data-value]:not([aria-disabled="true"])');
      if (b) setTimeout(function () { b.focus({ preventScroll: true }); }, 350);
    }

    bindAtc() {
      var self = this;
      if (!this.atc) return;
      this.atc.addEventListener('click', function (e) {
        if (self.atc.getAttribute('aria-disabled') === 'true' && !self.variant) {
          e.preventDefault();
          self.focusMissing();
        }
      });
    }

    bindSticky() {
      var self = this;
      this.sticky = this.querySelector('[data-cs-sticky]');
      if (!this.sticky || !this.atc) return;
      var btn = this.sticky.querySelector('[data-cs-sticky-btn]');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var en = entries[0];
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          self.sticky.classList.toggle('is-visible', show);
          self.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          btn.tabIndex = show ? 0 : -1;
        }).observe(this.atc);
      }
      btn.addEventListener('click', function () {
        if (!self.variant) { self.focusMissing(); return; }
        if (!self.variant.available || !self.form) return;
        if (self.form.requestSubmit) self.form.requestSubmit(self.atc);
        else self.atc.click();
      });
    }

    bindGuide() {
      var self = this;
      this.drawer = this.querySelector('[data-cs-guide]');
      if (!this.drawer) return;
      this.scrim = this.querySelector('[data-cs-scrim]');
      /* Move the drawer to <body> so no ancestor can trap the fixed position. */
      document.body.appendChild(this.drawer);
      if (this.scrim) document.body.appendChild(this.scrim);
      this.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cs-guide-open]');
        if (opener) { self.lastFocus = opener; self.openGuide(); }
      });
      [this.drawer, this.scrim].forEach(function (el) {
        if (!el) return;
        el.addEventListener('click', function (e) {
          if (e.target.closest('[data-cs-guide-close]')) { self.closeGuide(); return; }
          var tab = e.target.closest('[data-cs-tab]');
          if (tab) self.selectTab(tab);
        });
      });
      this.drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { self.closeGuide(); return; }
        if (e.key !== 'Tab') return;
        var f = focusables(self.drawer);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    }

    disconnectedCallback() {
      /* The theme editor re-renders sections; remove the drawer we moved to <body>. */
      if (this.drawer && this.drawer.parentNode === document.body) this.drawer.remove();
      if (this.scrim && this.scrim.parentNode === document.body) this.scrim.remove();
    }

    openGuide() {
      this.drawer.classList.add('is-open');
      if (this.scrim) this.scrim.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var close = this.drawer.querySelector('[data-cs-guide-close]');
      setTimeout(function () { if (close) close.focus(); }, 60);
    }

    closeGuide() {
      this.drawer.classList.remove('is-open');
      if (this.scrim) this.scrim.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    }

    selectTab(tab) {
      var name = tab.getAttribute('data-cs-tab');
      this.drawer.querySelectorAll('[data-cs-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      this.drawer.querySelectorAll('[data-cs-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-cs-panel') !== name; });
    }

    bindPairs() {
      this.querySelectorAll('[data-cs-pair]').forEach(function (card) {
        var jsonEl = card.querySelector('[data-cs-pair-json]');
        var openBtn = card.querySelector('[data-cs-pair-open]');
        if (!jsonEl || !openBtn) return;
        var data = JSON.parse(jsonEl.textContent);
        var confirm = card.querySelector('[data-cs-pair-confirm]');
        var colorSel = card.querySelector('[data-cs-pair-color]');
        var msg = card.querySelector('[data-cs-pair-msg]');
        var size = null;

        function find() {
          var color = colorSel ? colorSel.value : (data.colorIdx >= 0 && data.variants[0] ? data.variants[0].options[data.colorIdx] : null);
          for (var i = 0; i < data.variants.length; i++) {
            var v = data.variants[i];
            if (data.colorIdx >= 0 && v.options[data.colorIdx] !== color) continue;
            if (data.sizeIdx >= 0 && v.options[data.sizeIdx] !== size) continue;
            return v.available ? v : null;
          }
          return null;
        }
        function refresh() {
          var ready = data.sizeIdx < 0 || size != null;
          var v = ready ? find() : null;
          confirm.disabled = !v;
          if (msg) {
            msg.hidden = !(ready && !v);
            msg.textContent = ready && !v ? data.unavailable : '';
          }
        }

        openBtn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          openBtn.textContent = open ? openBtn.getAttribute('data-label-close') : openBtn.getAttribute('data-label-open');
        });
        card.addEventListener('click', function (e) {
          var p = e.target.closest('[data-pair-value]');
          if (!p) return;
          card.querySelectorAll('[data-pair-value]').forEach(function (x) { x.setAttribute('aria-checked', x === p ? 'true' : 'false'); });
          size = p.getAttribute('data-pair-value');
          refresh();
        });
        if (colorSel) colorSel.addEventListener('change', refresh);
        confirm.addEventListener('click', function () {
          var v = find();
          if (!v) return;
          var original = confirm.textContent;
          confirm.disabled = true;
          addToCart(v.id, 1)
            .then(function () {
              confirm.textContent = data.added;
              setTimeout(function () { confirm.textContent = original; confirm.disabled = false; }, 2000);
            })
            .catch(function (err) {
              confirm.disabled = false;
              if (msg) { msg.hidden = false; msg.textContent = err.message; }
            });
        });
        refresh();
      });
    }
  }

  class CsRecommendations extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this._loaded || !this.getAttribute('data-url')) return;
      if (this.querySelector('.cs-cards')) { this._loaded = true; return; }
      function load() {
        self._loaded = true;
        fetch(self.getAttribute('data-url'))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('cs-recommendations');
            if (fresh && fresh.querySelector('.cs-cards')) {
              self.innerHTML = fresh.innerHTML;
            } else {
              var wrap = self.closest('[data-cs-recs-section]');
              if (window.Shopify && window.Shopify.designMode) {
                self.innerHTML = '<p class="cs-gutter cs-guide-note">No recommendations for this product yet. Shopify fills this in once the product has related items. Hidden on the live store until then.</p>';
              } else if (wrap) {
                wrap.hidden = true;
              }
            }
          })
          .catch(function () {});
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      } else {
        load();
      }
    }
  }

  if (!customElements.get('cs-product')) customElements.define('cs-product', CsProduct);
  if (!customElements.get('cs-recommendations')) customElements.define('cs-recommendations', CsRecommendations);
})();
